module.exports = __webpack_public_path__ + "img/tip1.de310640.png";